import { useLiveQuery } from 'dexie-react-hooks';
import { useCallback, useEffect, useState } from 'react';
import { fetchTrips } from '../lib/api';
import { db } from '../lib/db';

/** Lista de viagens: lê do cache local (Dexie) e atualiza em segundo plano quando há rede. */
export function useTrips() {
  const trips = useLiveQuery(() => db.trips.orderBy('cachedAt').reverse().toArray(), []);
  const [error, setError] = useState<string>();
  const [refreshing, setRefreshing] = useState(false);

  const refresh = useCallback(async () => {
    setRefreshing(true);
    setError(undefined);
    try {
      const fresh = await fetchTrips();
      const cachedAt = Date.now();
      await db.trips.bulkPut(fresh.map((trip) => ({ ...trip, cachedAt })));
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Não foi possível atualizar as viagens');
    } finally {
      setRefreshing(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    trips: trips ?? [],
    loading: trips === undefined,
    refreshing,
    error,
    refresh,
  };
}
